import { trimSlashes } from "Util";
import { getOauthToken, requestRefreshToken } from "./Auth";
import axios from "axios";

const proxyRoot = process.env.REACT_APP_ROOT_API;
const oauthRoot = process.env.REACT_APP_OAUTH_SERVER;

export const buildProxyUrl = (uri, publication) => {
    const baseUrl = proxyRoot.replace("{client_code}", publication.client_code);
    return [trimSlashes(baseUrl), trimSlashes(uri)].join("/");
};

export const buildOauthUrl = (uri) => {
    return [trimSlashes(oauthRoot), trimSlashes(uri)].join("/");
};

export async function apiPost(uri, publication, data = {}, retryOnFail = true) {
    const furl = buildProxyUrl(uri, publication);
    let response;

    try {
        response = await axios.post(furl, data, {
            headers: {
                Authorization: "Bearer " + getOauthToken(),
                "X-Publication-Uuid": publication.uuid,
            },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (e) {
        if (!e.response) {
            throw Error(e);
        }
        if (e.response.status === 401 && retryOnFail === true) {
            const token = await requestRefreshToken();
            if (!token) {
                throw Error("Unable to refresh token");
            }
            return apiPost(uri, publication, data, false);
        }
        if (e.response.status !== 200) {
            // TODO error boundary
            throw Error(e.response.data);
        }
    }

    return false;
}

export async function apiPut(uri, publication, data = {}, retryOnFail = true) {
    const furl = buildProxyUrl(uri, publication);
    let response;

    try {
        response = await axios.put(furl, data, {
            headers: {
                Authorization: "Bearer " + getOauthToken(),
                "X-Publication-Uuid": publication.uuid,
            },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (e) {
        if (!e.response) {
            throw Error(e);
        }
        if (e.response.status === 401 && retryOnFail === true) {
            const token = await requestRefreshToken();
            if (!token) {
                throw Error("Unable to refresh token");
            }
            return apiPut(uri, publication, data, false);
        }
        if (e.response.status !== 200) {
            // TODO error boundary
            throw Error(e.response.data);
        }
    }

    return false;
}

export async function apiGet(
    uri,
    publication,
    data = {},
    retryOnFail = true,
    raw = false
) {
    const furl = buildProxyUrl(uri, publication);
    let response;

    try {
        response = await axios.get(furl, {
            headers: {
                Authorization: "Bearer " + getOauthToken(),
                "X-Publication-Uuid": publication.uuid,
            },
            params: data,
        });

        if (response.status === 200) {
            if (raw) {
                return response;
            }
            return response.data;
        }
    } catch (e) {
        if (!e.response) {
            throw Error(e);
        }
        if (e.response.status === 401 && retryOnFail === true) {
            const token = await requestRefreshToken();
            if (!token) {
                throw Error("Unable to refresh token");
            }
            return apiGet(uri, publication, data, false, raw);
        }
        if (e.response.status !== 200) {
            // TODO error boundary
            throw Error(e.response.data);
        }
    }

    return false;
}

export async function apiDel(uri, publication, retryOnFail = true) {
    const furl = buildProxyUrl(uri, publication);
    let response;

    try {
        response = await axios.delete(furl, {
            headers: {
                Authorization: "Bearer " + getOauthToken(),
                "X-Publication-Uuid": publication.uuid,
            },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (e) {
        if (!e.response) {
            throw Error(e);
        }
        if (e.response.status === 401 && retryOnFail === true) {
            const token = await requestRefreshToken();
            if (!token) {
                throw Error("Unable to refresh token");
            }
            return apiDel(uri, publication, false);
        }
        if (e.response.status !== 200) {
            // TODO error boundary
            throw Error(e.response.data);
        }
    }

    return false;
}

export async function oauthGet(uri, data = {}, retryOnFail = true) {
    const furl = buildOauthUrl(uri);
    let response;

    try {
        response = await axios.get(furl, {
            headers: {
                Authorization: "Bearer " + getOauthToken(),
            },
            params: data,
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (e) {
        if (!e.response) {
            throw Error(e);
        }
        if (e.response.status === 401 && retryOnFail === true) {
            const token = await requestRefreshToken();
            if (!token) {
                throw Error("Unable to refresh token");
            }
            return oauthGet(uri, data, false);
        }
        if (e.response.status !== 200) {
            // TODO error boundary
            throw Error(e.response.data);
        }
    }

    return false;
}

export async function oauthDel(uri, data = {}, retryOnFail = true) {
    const furl = buildOauthUrl(uri);
    let response;

    try {
        response = await axios.delete(furl, {
            headers: {
                Authorization: "Bearer " + getOauthToken(),
            },
            params: data,
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (e) {
        if (!e.response) {
            throw Error(e);
        }
        if (e.response.status === 401 && retryOnFail === true) {
            const token = await requestRefreshToken();
            if (!token) {
                throw Error("Unable to refresh token");
            }
            return oauthDel(uri, data, false);
        }
        if (e.response.status !== 200) {
            // TODO error boundary
            throw Error(e.response.data);
        }
    }

    return false;
}

export async function oauthPut(uri, data = {}, retryOnFail = true) {
    const furl = buildOauthUrl(uri);
    let response;

    try {
        response = await axios.put(furl, data, {
            headers: {
                Authorization: "Bearer " + getOauthToken(),
            },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (e) {
        if (!e.response) {
            throw Error(e);
        }
        if (e.response.status === 401 && retryOnFail === true) {
            const token = await requestRefreshToken();
            if (!token) {
                throw Error("Unable to refresh token");
            }
            return oauthPut(uri, data, false);
        }
        if (e.response.status !== 200) {
            // TODO error boundary
            throw Error(e.response.data);
        }
    }

    return false;
}

export async function oauthPost(uri, data = {}, retryOnFail = true) {
    const furl = buildOauthUrl(uri);
    let response;

    try {
        response = await axios.post(furl, data, {
            headers: {
                Authorization: "Bearer " + getOauthToken(),
            },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (e) {
        if (!e.response) {
            throw Error(e);
        }
        if (e.response.status === 401 && retryOnFail === true) {
            const token = await requestRefreshToken();
            if (!token) {
                throw Error("Unable to refresh token");
            }
            return oauthPost(uri, data, false);
        }
        if (e.response.status !== 200) {
            // TODO error boundary
            throw Error(e.response.data);
        }
    }

    return false;
}
